// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"7f992e6a","391":"4f59e07a","429":"6a8c5bb2","432":"9993d7e5","488":"e3bef7b7","590":"49dc176b","654":"e0f43bc7","710":"0f4078ac"}[chunkId] + ".chunk.js";
};